import { useLayoutEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useKeyboardOpen } from "../../hooks/useKeyBoardOpen";
import DesktopLayout from "./desktop";
import LocationTracker from "../../lib/location-tracker";

type AuthLayoutProps = {
  topSafe?: boolean;
};

export default function NoneNaviLayout({ topSafe = false }: AuthLayoutProps) {
  const kbOpen = useKeyboardOpen();
  const mainRef = useRef<HTMLElement>(null);
  const { pathname } = useLocation();

  // main은 라우트가 바뀌어도 유지되는 스크롤 컨테이너이므로
  // 페이지 이동 시 이전 페이지의 scrollTop이 그대로 남는다. 진입 시 초기화한다.
  // (이전 위치 복원이 필요한 페이지는 각자 rAF 이후에 복원하므로 이 초기화보다 나중에 적용된다.)
  useLayoutEffect(() => {
    mainRef.current?.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div
      className="w-full min-h-dvh flex justify-center bg-[#f5f5f5] gap-[168px]"
      style={{
        paddingTop: topSafe ? "var(--safe-area-inset-top)" : 0,
        paddingBottom: kbOpen ? "var(--safe-area-inset-bottom)" : "var(--safe-area-inset-bottom)",
        overscrollBehavior: "none",
      }}
    >
      <DesktopLayout />
      <div
        className="
          w-full h-dvh bg-white flex flex-col relative
          max-w-[440px]
          shadow-[0px_30px_60px_0_rgba(0,0,0,0.1)]
        "
      >
        <main
          ref={mainRef}
          className="flex-1 overflow-y-auto overscroll-contain"
        >
          <LocationTracker />
          <Outlet />
        </main>
      </div>
    </div>
  );
}